import { Controller } from "@hotwired/stimulus"

// Focus/blur toggle (mobile sidebar). Keeps aria-expanded in sync with focus.
export default class extends Controller {
  connect() {
    this.syncExpanded = this.syncExpanded.bind(this)
    this.element.addEventListener("focus", this.syncExpanded)
    this.element.addEventListener("blur", this.syncExpanded)
    this.syncExpanded()
  }

  disconnect() {
    this.element.removeEventListener("focus", this.syncExpanded)
    this.element.removeEventListener("blur", this.syncExpanded)
  }

  toggle(event) {
    event.preventDefault()
    if (this.element === document.activeElement) {
      this.element.blur()
    } else {
      this.element.focus()
    }
  }

  syncExpanded() {
    this.element.setAttribute(
      "aria-expanded",
      this.element === document.activeElement ? "true" : "false"
    )
  }
}
